








































































































































































import { Component } from "vue-property-decorator";
import Vue from "vue";
import { PatientFormData } from "@/types";
import { appModule } from "@/store/modules/app";
import { isValidEmail, isValidPhone, isValidBirthday } from "@/utils/app-util";
import { patientModule } from "@/store/modules/patients";
import { placeModule } from "@/store/modules/place";
import { GENDER } from "@/utils/store-util";
import lodash from "lodash";

@Component
export default class PatientForm extends Vue {
  rules = {
    email: [() => isValidEmail(this.patientFormData.email)],
    phone: [
      () => !!this.patientFormData.phone ||'This field is required',
      () => isValidPhone(this.patientFormData.phone)
    ],
    iid: [
      () => !!this.patientFormData.iid ||'This field is required',
      () => this.patientFormData.iid.length<=10 || '身分證字號不可超過10位'
    ],
    birthday: [
      () => !!this.patientFormData.birthday || 'This field is required',
      () => isValidBirthday(this.patientFormData.birthday)
    ],
  };

  avatar = "";
  get loading() {
    return patientModule.loading;
  }
  get place() {
    return placeModule.place;
  }
  patientFormData: PatientFormData = {
    birthday: "",
    gender: "",
    name: "",
    phone: "",
    email: "",
    iid: "",
    role: "Patient",
    place: "",
    title: "",
  };
  requestBody: PatientFormData = {
    birthday: "",
    gender: "",
    name: "",
    phone: "",
    email: "",
    iid: "",
    role: "Patient",
    place: "",
    title: "",
  };

  async save() {
    this.requestBody = lodash.cloneDeep(this.patientFormData);
    (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if(isValidEmail(this.requestBody.email)!==true||this.requestBody.phone === ""||isValidPhone(this.requestBody.phone)!==true||this.requestBody.gender===""||this.requestBody.name===""||this.requestBody.iid===""||this.requestBody.iid.length>10||this.requestBody.place===""||this.requestBody.birthday===""||isValidBirthday(this.requestBody.birthday)!==true){
      appModule.sendErrorNotice("表格有誤");
      return;
    }
    this.requestBody.gender = Object.keys(GENDER).find(
      (key) => GENDER[key] === this.requestBody.gender
    );
    await placeModule.placetoCode(this.requestBody);

    patientModule.createPatient(this.requestBody);
  }

  resetForm() {
    this.patientFormData = {
      birthday: "",
      gender: "",
      name: "",
      phone: "",
      email: "",
      iid: "",
      role: "Patient",
      place: "",
      title: "",
    };
    appModule.setSnackbar;
  }

  cancel() {
    this.$router.push({ name: "個案名單" });
  }
}
